// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"640":"d7c0c0ac8a48710b","988":"98827242992c6382"}[chunkId] + ".js";
};